import * as actionTypes from './actionTypes'
import axios from '../../httpClients/axios-datamerch'
import {authHeaders} from '../../helpers'
import {clearNotes} from './note'
import { history } from '../../Router'
import {addToast} from './toasts'
import { Subject, SubjectRounded } from '@mui/icons-material'

export const addFeedbackStart = () => {
  return {
    type: actionTypes.ADD_FEEDBACK_START
  }
}

export const addFeedbackSuccess = (id, FeedbackData) => {
  return {
    type: actionTypes.ADD_FEEDBACK_SUCCESS,
    id: id,
    FeedbackData: FeedbackData
  }
}

export const addFeedbackFail = (error) => {
  return {
    type: actionTypes.ADD_FEEDBACK_FAIL,
    error: error
  }
}

export const addFeedback = (FeedbackData, token) => {
    console.log(FeedbackData)
    const modifiedFeedbackData = {
    Feedback: {
      name: FeedbackData.name,
      email: FeedbackData.email,
      feedbacktype: FeedbackData.feedbacktype,
      subject: FeedbackData.subject,
      description: FeedbackData.description
    }
  }
  
  return dispatch => {
    dispatch(addFeedbackStart())
    let url = '/feedbacks'
    let config = authHeaders()
    axios.post(url, modifiedFeedbackData, config)
    .then(response => {
      if (response){
        const data = response.data.data
        dispatch(addFeedbackSuccess(data.resource_id, data))
        dispatch(addToast({
          message: 'Feedback has been submitted to DataMerch.',
          severity: 'success'
        }))
        dispatch(initializeAddFeedback())
      } else {
        dispatch(addFeedbackFail('An error occurred while attempting to create Feedback.'))
        dispatch(addToast({
          message: 'An error occurred while attempting to create Feedback.',
          severity: 'error',
          duration: null
        }))
      }
    })
    .catch(error => {
      dispatch(addFeedbackFail(error.response.data.errors))
      dispatch(addToast({
        message: error.response.data.errors,
        severity: 'error',
        duration: null
      }))
    })
  }
}

export const initializeAddFeedback = () => {
  return {
    type: actionTypes.INITIALIZE_ADD_FEEDBACK
  }
}

export const openFeedbackDialog = () => {
    return {
      type: actionTypes.OPEN_FEEDBACK_DIALOG
    }
  }
  
  export const closeFeedbackDialog = () => {
    return {
      type: actionTypes.CLOSE_FEEDBACK_DIALOG
    }
  }
  
